import { CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Heading, Image } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StreakList from './StreakList';
import AboutStreak from './AboutStreak';
import ModalTemplate from '../../common/ModalTemplate';
import StreakModalContent from './StreakModalContent';
import ModalTemplateV2 from '../../common/ModalTemplateV2';
import HeaderWithCloseIcon from '../../common/HeaderWithCloseIcon';
import { useStreaks } from '../../../hooks/V2/useUser';
import ShareModal from '../../common/V2/SocialMedia/ShareModal';
const Streaks = () => {
	const navigate = useNavigate();

	// const [streaksDone, setStreaksDone] = React.useState(3);
	const { data: streakCount } = useStreaks();
	const [showStreakCompletedModal, setShowStreakCompletedModal] = React.useState(false);
	const streakLimit = 7;
	useEffect(() => {
		setShowStreakCompletedModal(false);
		// if (streakCount >= 7) {
		// 	setStreakLimit(streakCount);
		// }
	}, [streakCount]);
	const [isOpen, setIsOpen] = useState(false);
	const onClose = () => setIsOpen(false);
	return (
		<Box h="full">
			<Box h="full" position="relative">
				<Box position="absolute" top="0px" w="full" bg="white" display={{ lg: 'none' }}>
					<HeaderWithCloseIcon title="Streaks" closeIconPath="/dashboard" />
				</Box>
				<Box h="full" p="16px" display={'flex'} justifyContent={'center'} bgColor={'#F6EDE7'}>
					<Box my="auto">
						<Image mx="auto" src="/images/streaks-main.svg" />
						<Box mt="24px">
							<StreakList streakLimit={streakLimit} streaksDone={streakCount} />
							<AboutStreak streaksDone={streakCount} />
							<Box mt="24px" display={'flex'} justifyContent={'center'} gap="16px">
								<Button
									onClick={() => {
										navigate('/dashboard');
									}}
									color={streakCount >= 7 ? '#4358F6' : '#fff'}
									variant={streakCount >= 7 ? 'secondary' : 'primary'}
									bgColor={streakCount >= 7 ? '#F2F6FF' : '#4358F6'}
								>
									Start Practicing
								</Button>
								{streakCount >= 7 && (
									<Button onClick={() => setShowStreakCompletedModal(true)} bgColor={'#4358F6'} variant="primary">
										Share
										<Image ml="8px" src="/images/streak-share.svg" />
									</Button>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>

			<ModalTemplateV2
				closeOnOverlayClick={true}
				isOpen={showStreakCompletedModal}
				onClose={() => {
					setShowStreakCompletedModal(false);
				}}
				showConfetti={true}
				hideIconWithConfetti={true}
				autoCloseInSeconds={30}
				extra={
					<Box>
						<StreakModalContent streakLimit={streakCount} />
						<Button mt="16px" _focus={{ outline: 'none' }} outline="none" onClick={() => setIsOpen(true)} bgColor={'#4358F6'} variant="primary">
							Share
							<Image ml="8px" src="/images/streak-share.svg" />
						</Button>
					</Box>
				}
			/>
			<ShareModal
				title="Hurray! I have completed 7 days streaks."
				shareUrl={'https://masai-website-images.s3.ap-south-1.amazonaws.com/Streak_card_35597d9026.png' || ''}
				isOpen={isOpen}
				onClose={onClose}
			/>
		</Box>
	);
};

export default Streaks;
